import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { useVrmSaleRoDetailModel } from "../vrmBillSaleRoModel";
import { formatNum } from "@/utils/utils";
import { RouterParamType } from "@/model/navModel";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { lookDesc } = useVrmSaleRoDetailModel();
    const retuenText = (field: string, money: boolean = false) => {
        let desc: any = lookDesc
        return money ? `￥${formatNum(desc[field])}` : formatNum(desc[field]);
    }
    const orderStatistics: IDescription[] = [
        {
            label: "退货项数",
            value: retuenText('itemNumAll'),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "退货数量",
            value: retuenText('numAll'),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "退货总金额",
            value: retuenText('totalAll'),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}